import { createElement } from "react";
import { Outlet, RouteObject } from "react-router-dom";

import { AuthProvider, WithAuthenticationRequired } from "../auth";
import ConfigChecker from "../config/ConfigChecker";

/**
 * IMPORTANT
 * The version of `react-router-dom` must be the exact same as the one used by `react-admin`
 * You can run `pnpm why react-router-dom` to check the version
 * Otherwise react-admin will not detect our router and fallback to internal HashRouter
 * Doc: https://marmelab.com/react-admin/Routing.html#using-a-custom-router
 */

export default [
  {
    element: (
      <ConfigChecker>
        <AuthProvider>
          <Outlet />
        </AuthProvider>
      </ConfigChecker>
    ),
    children: [
      {
        path: "login",
        lazy: () => import("../auth/login"),
      },
      {
        path: "logout",
        lazy: () => import("../auth/logout"),
      },
      // logged in routes
      {
        element: createElement(WithAuthenticationRequired),
        children: [
          {
            path: "*",
            lazy: () => import("../admin/AdminPanel"),
          },
        ],
      },
    ],
  },
] satisfies RouteObject[];
